import { render } from "./indexReserveComponent.vue?vue&type=template&id=370e2954"
import script from "./indexReserveComponent.vue?vue&type=script&lang=js"
export * from "./indexReserveComponent.vue?vue&type=script&lang=js"

import "./indexReserveComponent.vue?vue&type=style&index=0&id=370e2954&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__